// extracted by mini-css-extract-plugin
export default {"container":"IdentityInformation_container__n+hnv","inlineInputs":"IdentityInformation_inlineInputs__U1TVo"};